import { render, staticRenderFns } from "./CompletedAppointList.vue?vue&type=template&id=11371f1c"
import script from "./CompletedAppointList.vue?vue&type=script&lang=js"
export * from "./CompletedAppointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports